const ProfileTab = ({ employeeData, darkMode }) => {
  return (
    <div>
      <h3 className={`text-xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-slate-800'}`}>O Meu Perfil</h3>
      
      {employeeData ? (
        <div className="grid md:grid-cols-2 gap-6">
          <div className="space-y-4">
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Nome Completo</label>
              <p className={`font-medium ${darkMode ? 'text-white' : 'text-slate-800'}`}>{employeeData.name}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Email</label>
              <p className={darkMode ? 'text-white' : 'text-slate-800'}>{employeeData.email}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Departamento</label>
              <p className={darkMode ? 'text-white' : 'text-slate-800'}>{employeeData.department || '-'}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Cargo</label>
              <p className={darkMode ? 'text-white' : 'text-slate-800'}>{employeeData.position || '-'}</p>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>NIF</label>
              <p className={`font-mono ${darkMode ? 'text-white' : 'text-slate-800'}`}>{employeeData.nif || '-'}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Nº Colaborador</label>
              <p className={`font-mono ${darkMode ? 'text-white' : 'text-slate-800'}`}>{employeeData.employee_number || employeeData.employee_id}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Data Admissão</label>
              <p className={darkMode ? 'text-white' : 'text-slate-800'}>{employeeData.hire_date || '-'}</p>
            </div>
            <div>
              <label className={`text-sm ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Telemóvel</label>
              <p className={darkMode ? 'text-white' : 'text-slate-800'}>{employeeData.phone || '-'}</p>
            </div>
          </div>
        </div>
      ) : (
        <p className={`text-center py-8 ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>Dados não disponíveis</p>
      )}
    </div>
  );
};

export default ProfileTab;
